import type { CaseStatus } from '../../lib/api/cases';

/**
 * `CaseStatus`'s own vocabulary -> `status.*`'s i18n key, the one place the
 * two differ (`in_progress` vs. `inProgress`) — the app-wide `status`
 * section (`StatusPill`'s own six-state vocabulary) already carries every
 * label a case status needs, so this module adds no new copy of its own.
 *
 * `as const satisfies` keeps every value a literal key `i18next.d.ts`
 * recognises, rather than widening to `string` — a template-string builder
 * (`` `status.${status}` ``) compiles but fails `npm run typecheck` against
 * the typed `t()` overloads this codebase relies on (task 19).
 */
export const STATUS_LABEL_KEY = {
  open: 'status.open',
  in_progress: 'status.inProgress',
  waiting: 'status.waiting',
  escalated: 'status.escalated',
  closed: 'status.closed',
  cancelled: 'status.cancelled',
} as const satisfies Record<CaseStatus, string>;

export function statusLabelKey(status: CaseStatus): (typeof STATUS_LABEL_KEY)[CaseStatus] {
  return STATUS_LABEL_KEY[status];
}
